import {IMultilingualDataOption, ISurveyMultipleChoiceQuestion} from '../../models/survey/ISurveyQuestion';
import {get} from 'lodash';

export function getMultipleChoiceQuestionOptions(element: ISurveyMultipleChoiceQuestion): IMultilingualDataOption[] {
    return get(element, 'question.data.options');
}
